import { render, staticRenderFns } from "./StatementCheck.vue?vue&type=template&id=6fe28ec2&scoped=true&"
import script from "./StatementCheck.vue?vue&type=script&lang=js&"
export * from "./StatementCheck.vue?vue&type=script&lang=js&"
import style0 from "./StatementCheck.vue?vue&type=style&index=0&id=6fe28ec2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe28ec2",
  null
  
)

export default component.exports